import { useLocation } from 'react-router-dom';
import SEOHead from './SEOHead';

/**
 * Componente que envuelve la aplicación y maneja SEO dinámico por ruta
 */
const SEOWrapper = ({ children }) => {
  const location = useLocation();
  
  // Configuraciones SEO por ruta
  const getSEOConfig = () => {
    try {
    const baseUrl = 'https://revvly.cl';
    
    switch (location.pathname) {
      case '/':
      case '/dashboard':
        return {
          title: 'Dashboard - Revvly | Software para Talleres Automotrices',
          description: 'Panel de control completo para tu taller. Visualiza estadísticas, citas, ingresos y rendimiento en tiempo real.',
          keywords: 'dashboard taller, estadísticas taller, panel control automotriz, analytics taller chile',
          url: `${baseUrl}/dashboard`,
          structuredData: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "Dashboard Revvly",
            "description": "Panel de control para talleres automotrices",
            "url": `${baseUrl}/dashboard`,
            "applicationCategory": "BusinessApplication"
          }
        };
        
      case '/taller':
        return {
          title: 'Revvly - Software para Talleres Automotrices Chile | Gestión Integral',
          description: 'Software líder para gestión de talleres automotrices en Chile. 30 días gratis, sin tarjeta de crédito. Aumenta tu productividad hasta 300%.',
          keywords: 'software taller automotriz chile, gestión talleres mecánicos, sistema talleres chile, software mecánico chile',
          url: `${baseUrl}/taller`,
          structuredData: {
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            "name": "Revvly - Software para Talleres Automotrices",
            "description": "Sistema integral de gestión para talleres mecánicos en Chile",
            "url": `${baseUrl}/taller`,
            "applicationCategory": "BusinessApplication",
            "operatingSystem": "Web"
          }
        };
        
      case '/cliente':
        return {
          title: 'Portal Cliente - Revvly | Seguimiento de Servicios Automotrices',
          description: 'Portal exclusivo para clientes de talleres Revvly. Consulta el estado de tu vehículo, historial de servicios y programa citas.',
          keywords: 'portal cliente taller, seguimiento vehículo, historial servicios automotriz, citas taller online',
          url: `${baseUrl}/cliente`,
          structuredData: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "Portal Cliente Revvly",
            "description": "Portal para clientes de talleres automotrices",
            "url": `${baseUrl}/cliente`
          }
        };
        
      case '/pricing':
        return {
          title: 'Precios y Planes - Revvly | Software para Talleres Automotrices',
          description: 'Planes flexibles para talleres de todos los tamaños. Desde plan gratuito hasta enterprise. 30 días de prueba sin compromiso.',
          keywords: 'precios software taller, planes talleres automotrices, costo sistema taller, precio software mecánico',
          url: `${baseUrl}/pricing`,
          structuredData: {
            "@context": "https://schema.org",
            "@type": "Product",
            "name": "Planes Revvly",
            "description": "Planes de software para talleres automotrices",
            "url": `${baseUrl}/pricing`
          }
        };
        
      case '/citas':
        return {
          title: 'Gestión de Citas - Revvly | Calendario Inteligente para Talleres',
          description: 'Sistema avanzado de gestión de citas para talleres. Calendario inteligente, recordatorios automáticos y optimización de horarios.',
          keywords: 'gestión citas taller, calendario taller automotriz, sistema citas mecánico, agenda taller chile',
          url: `${baseUrl}/citas`,
          structuredData: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "Gestión de Citas Revvly",
            "description": "Sistema de citas para talleres automotrices",
            "url": `${baseUrl}/citas`
          }
        };
        
      case '/clientes':
        return {
          title: 'Gestión de Clientes - Revvly | CRM para Talleres Automotrices',
          description: 'CRM completo para talleres. Gestiona clientes, historial de servicios, vehículos y comunicación centralizada.',
          keywords: 'crm taller automotriz, gestión clientes taller, base datos clientes mecánico, software clientes chile',
          url: `${baseUrl}/clientes`
        };
        
      case '/vehiculos':
        return {
          title: 'Gestión de Vehículos - Revvly | Base de Datos Automotriz',
          description: 'Base de datos completa de vehículos. Catálogo homologado en Chile, fichas técnicas y historial de servicios.',
          keywords: 'gestión vehículos taller, base datos automotriz, catálogo vehículos chile, ficha técnica vehículos',
          url: `${baseUrl}/vehiculos`
        };
        
      case '/servicios':
        return {
          title: 'Catálogo de Servicios - Revvly | Servicios Automotrices',
          description: 'Gestiona tu catálogo completo de servicios automotrices. Precios, tiempos estimados y categorización avanzada.',
          keywords: 'servicios taller automotriz, catálogo servicios mecánico, precios servicios taller, gestión servicios chile',
          url: `${baseUrl}/servicios`
        };
        
      case '/repuestos':
        return {
          title: 'Inventario de Repuestos - Revvly | Gestión Stock Automotriz',
          description: 'Control total de inventario de repuestos. Stock en tiempo real, alertas automáticas y gestión de proveedores.',
          keywords: 'inventario repuestos automotriz, stock repuestos taller, gestión inventario mecánico, control repuestos chile',
          url: `${baseUrl}/repuestos`
        };
        
      case '/mantenimientos':
        return {
          title: 'Órdenes de Trabajo - Revvly | Gestión Mantenimientos',
          description: 'Gestión completa de órdenes de trabajo y mantenimientos. Seguimiento en tiempo real y documentación automática.',
          keywords: 'órdenes trabajo taller, gestión mantenimientos automotriz, seguimiento servicios taller, documentación servicios',
          url: `${baseUrl}/mantenimientos`
        };
        
      default:
        return {
          title: 'Revvly - Software para Talleres Automotrices Chile',
          description: 'Software líder para gestión de talleres automotrices en Chile. Aumenta tu productividad hasta 300%.',
          keywords: 'software taller automotriz chile, gestión talleres, sistema talleres mecánicos',
          url: baseUrl
        };
    }
    } catch (error) {
      console.error('Error in SEOWrapper getSEOConfig:', error);
      // Retornar configuración por defecto en caso de error
      return {
        title: 'Revvly - Software para Talleres Automotrices Chile',
        description: 'Software líder para gestión de talleres automotrices en Chile. Aumenta tu productividad hasta 300%.',
        keywords: 'software taller automotriz chile, gestión talleres, sistema talleres mecánicos',
        url: 'https://revvly.cl'
      };
    }
  };
  
  const seoConfig = getSEOConfig();
  
  return (
    <>
      <SEOHead {...seoConfig} />
      {children}
    </>
  );
};

export default SEOWrapper;